import React, { useState } from 'react'
import styled from 'styled-components'
import { Image, breakpoints, Button, saveIsUserAdult, getIsUserAdult, ModalBackground } from '@ecommerce/shared'

const ModalWrapper = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 10;
  top: 0;
  backdrop-filter: blur(5px);

  .AgeModal__background {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`

const ModalInner = styled.div`
  width: 350px;
  z-index: 1;
  position: relative;
  min-width: 350px;
  max-width: 500px;
  background: ${({ theme }) => theme.colors.red};
  box-shadow: ${({ theme }) => theme.boxShadow.lvlTwo};
  border-radius: ${({ theme }) => theme.borderRadius};
  padding: 50px 40px 30px;

  p {
    color: ${({ theme }) => theme.colors.white};
    font-size: 24px;
    text-align: center;

    &.top-text {
      margin-top: 0;
    }
  }

  img {
    width: 200px;
    margin: auto;
    display: block;
    min-height: 77px;
  }

  @media screen and (${breakpoints.tabletLandscape.min}) {
    width: 500px;
    padding: 50px 100px;
  }
`

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    width: 48%;
    background: none;

    &.deny {
      border: 1px solid ${({ theme }) => theme.colors.white};
    }

    &.confirm {
      background: ${({ theme }) => theme.colors.white};
      color: ${({ theme }) => theme.colors.red};
    }
  }
`

type Props = {
  hideModal: boolean
}

const AgeModal = ({ hideModal }: Props) => {
  const [isNewUser, setIsNewUser] = useState(!getIsUserAdult())
  const [userIsAdult, setUserIsAdult] = useState<boolean | null>(null)

  const onButtonClick = (confirm: boolean): void => {
    setUserIsAdult(confirm)

    if (confirm) {
      saveIsUserAdult()
      setIsNewUser(false)
    }
  }

  if (hideModal) return null

  return (
    <div>
      {isNewUser && (
        <ModalWrapper>
          <ModalBackground className="AgeModal__background">
            <ModalInner>
              <p className="top-text">Bienvenido a</p>
              <Image
                src="https://images.ctfassets.net/16npdkkoi5mj/4EAocVvRjUs3wHYN7PiSDB/f89865bb82569f8a649d1c07fbfbfbd5/CCO_-_BLANCO_-_SVG.svg"
                alt=" "
                preload={false}
              />
              {userIsAdult === null ? (
                <>
                  <p>¿Eres mayor de 18 años?</p>
                  <ButtonsWrapper>
                    <Button onClick={() => onButtonClick(false)} className="deny" data-test="age-deny">
                      No
                    </Button>
                    <Button className="confirm" onClick={() => onButtonClick(true)} data-test="age-confirm">
                      Si
                    </Button>
                  </ButtonsWrapper>
                </>
              ) : (
                <p>Lamentablemente debes ser mayor de edad para poder ingresar.</p>
              )}
            </ModalInner>
          </ModalBackground>
        </ModalWrapper>
      )}
    </div>
  )
}

export default AgeModal
